import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'
import mgs_alert from '../../sounds/MGS_alert.mp3'

import { shufflaa } from '../../utils/randomize'

import { data_base, data_A, data_AA, data_B, data_C } from './data/data_03_stairs_down.js'
import start from './images/portaat_down/start_small.gif'

// import sticks_down from './images/portaat_down/sticks_down.gif'
import sticks_down from './images/portaat_down/sticks_down_small.gif'
// import right_foot_down from './images/portaat_down/right_foot_down.gif'
import right_foot_down from './images/portaat_down/right_foot_down_small.gif'
// import left_foot_down_and_fall from './images/portaat_down/left_foot_down_and_fall.gif'
import left_foot_down_and_fall from './images/portaat_down/left_foot_down_and_fall_small.gif'
// import return_sticks_up from './images/portaat_down/return_sticks_up.gif'
import return_sticks_up from './images/portaat_down/return_sticks_up_small.gif'
// import left_foot_follows_sticks from './images/portaat_down/left_foot_follows_sticks_ver2.gif'
import left_foot_follows_sticks from './images/portaat_down/left_foot_follows_sticks_ver2_small.gif'
// import right_foot_follows_sticks_and_left from './images/portaat_down/right_foot_follows_sticks_and_left.gif'
import right_foot_follows_sticks_and_left from './images/portaat_down/right_foot_follows_sticks_and_left_small.gif'
// import right_foot_step_over from './images/portaat_down/right_foot_step_over.gif'
import right_foot_step_over from './images/portaat_down/right_foot_step_over_small.gif'

// import horjahdus_alasp from './images/portaat_down/horjahdus_alasp.gif'
import horjahdus_alasp from './images/portaat_down/horjahdus_alasp_small.gif'
// import horjahdus from './images/portaat_down/horjahdus_1_image.gif'
import horjahdus from './images/portaat_down/horjahdus_1_image_small.gif'

// import return_right_foot_up from './images/portaat_down/return_right_foot_up.gif'
import return_right_foot_up from './images/portaat_down/return_right_foot_up_small.gif'

import Noppa from '../../additionalComponents/Noppa.js';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


const StairsDown = ({ scoreHandler, visibilityHandler, soundsOn }) => {


    let lista = null

    //Statemjat
    const [teksti, setTeksti] = useState('')
    const [optiot1, setOptiot1] = useState([])
    const [optiot2, setOptiot2] = useState([])

    const [image, setImage] = useState(start)

    const [time1, setTime1] = useState(0)
    const [tarvittavaNopanArvo, setTarvittavaNopanArvo] = useState(null)
    const [noppaMsg, setNoppaMsg] = useState('')
    const [continuable, setContinuable] = useState(false)
    const [nextScene, setNextScene] = useState('')
    const [showModal, setShowModal] = useState(false);
    const [closeActive, setCloseActive] = useState(false);
    const [nopataan, setNopataan] = useState(false);

    const [horjahtanut, setHorjahtanut] = useState(false);



    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [playMgsAlert] = useSound(mgs_alert);


    //populoi aluksi teksti + optiot (alkuperäinen järjestys)
    useEffect(() => {
        setOptiot1(data_base.optiot)
        setTeksti(data_base.kysymysteksti)
        setTime1(Date.now())
    }, [])

    // optiot2:een shufflattu järjestys
    useEffect(() => {//
        if (optiot1.length != 0) {
            setOptiot2(shufflaa(optiot1))
        }
    }, [optiot1])



    const handleClose = () => {

        setShowModal(false);
    }
    const handleShowModal = () => {
        setShowModal(true);
        setCloseActive(false)
    }

    const handlaaArvontatulos = (e) => {
        if (e >= tarvittavaNopanArvo) {

            setOptiot1(data_base.optiot)
            setImage(start)
            setTeksti("Huh, se oli lähellä, yritetään vielä uudelleen alusta. "
                + data_base.kysymysteksti)


        }
        else {
            setTeksti("Pena kaatui, Game over")
            setImage(horjahdus_alasp)
            setOptiot2([])
            // Lisää lopetustoimenpiteet



        }
        setNopataan(false)
        setCloseActive(true)//aktivoi modaalin sulkunapin
        setContinuable(true)

    }


    const klikattuKuvaa = (optio) => {



        switch (optio.valinta) {
            case "A":
                setImage(sticks_down)
                setOptiot1(data_A.optiot)
                setTeksti(data_A.kysymysteksti)
                break;
            case "AA":
                setImage(left_foot_follows_sticks)
                setTeksti(data_AA.kysymysteksti)
                setOptiot1(data_AA.optiot)
                break;

            case "AAA":
                setImage(right_foot_follows_sticks_and_left)
                setTeksti("Hyvä, osaat ohjata sekä ylös- että alaspäin oikeaoppisesti.")
                if (horjahtanut) {
                    data_AA.optiot[0].pisteet = 0.5 * data_AA.optiot[0].pisteet
                }

                scoreHandler(data_AA.optiot[0], data_AA.scene, data_AA.maxp)
                visibilityHandler("portaat alas ok")

                break;
            case "AAB":
                setImage(right_foot_step_over)// seur askelmalle eli yli
                // setImage(horjahdus_alasp)
                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 2, hän ei kaadu!")
                setHorjahtanut(true)
                setTarvittavaNopanArvo(2)
                setNopataan(true)
                break;




            case "AB"://palauta sauvat takaisin  ylös
                setImage(return_sticks_up)
                setOptiot1(data_base.optiot)
                setTeksti(data_base.kysymysteksti)
                break;
            case "AC"://laske oikea jalka sauvojen väliin -horjahtaa

                setImage(horjahdus)
                if (soundsOn) {
                    playMgsAlert()
                }
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 3, hän ei kaadu!")
                setHorjahtanut(true)
                setTarvittavaNopanArvo(3)
                setNopataan(true)


                break;

            case "B":
                setImage(right_foot_down)
                setOptiot1(data_B.optiot)
                setTeksti(data_B.kysymysteksti)
                break;
            case "BA":
                // palauttaa oikean ylös --> start
                setImage(return_right_foot_up)
                setOptiot1(data_base.optiot)
                setTeksti(data_base.kysymysteksti)
                break;
            case "BB":
                // siirtää sauvat alas oikean jalan kanssa samalle askelmalle --> horjahdus
                if (soundsOn) {
                    playMgsAlert()
                }
                setImage(horjahdus_alasp)
                setTeksti("PENA HORJAHTI - heitä noppaa - jos saat vähintään 4, hän ei kaadu!")
                setHorjahtanut(true)
                setTarvittavaNopanArvo(4)
                setNopataan(true)
                break;


            case "C":
                //vasen jalka ennen sauvoja alas - horjahdus
                if (soundsOn) {
                    playMgsAlert()
                }
                setImage(left_foot_down_and_fall)
                setTeksti("PENA KAATUU - Game over")
                // setHorjantanut(true)
                // setTarvittavaNopanArvo(7)
                // setNopataan(true)
                break;






        }



    }

    if (optiot2.length != 0) {
        lista = optiot2.map(optio =>
            <li key={optio.id}>

                <span className='clickable'

                    onClick={() => klikattuKuvaa(optio)}

                >
                    {optio.teksti}
                </span>
            </li>
        );
    }
    return (

        <div className='sceneContainer'>

            <div id='image'>
                <img className='sameSizeImg' src={image} alt='kuva' />
            </div>

            <div id='question'>
                <h5>{(teksti != null && teksti != "") ? teksti : null}</h5>
            </div>

            <div id='actions'>


                {!nopataan ? <ul>
                    {lista}
                </ul> : null}

                {nopataan ? <>
                    <Button variant="primary" onClick={handleShowModal}>
                        Heitä noppaa
                    </Button>
                </> : null}

                <Modal
                    show={showModal}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                >


                    {/* <Modal.Header closeButton>
                                <Modal.Title>Modal title</Modal.Title>
                            </Modal.Header> */}
                    <Modal.Body>
                        <Noppa
                            soundsOn={soundsOn}
                            handlaa={handlaaArvontatulos}
                            tarvittavaNopanArvo={tarvittavaNopanArvo}
                        // sulku={handleClose}
                        />


                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}
                            disabled={!closeActive}
                        >
                            Close
                        </Button>

                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    )

}

export default StairsDown